import React from "react"
import styled from "@emotion/styled"
import Header from "./Header"
import InfoBanner from "@nvdb-rapport/shared/src/components/InfoBanner"
import { UIModel, UIAction } from "../../store/ui"

interface LayoutProps {
  children: React.ReactNode
  uiState: UIModel
  uiDispatch: React.Dispatch<UIAction>
}

export default function Layout({ children, uiState, uiDispatch }: LayoutProps) {
  return (
    <AppContainer>
      <Header uiState={uiState} uiDispatch={uiDispatch} />
      <InfoBanner />
      {children}
    </AppContainer>
  )
}

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #f6f6f6;
`
